import React, { Component } from 'react';
import { connect } from 'react-redux';

import { selectTool } from '../actions';
import { transformations } from '../utilities';


class Button extends Component {
  render() {

    let ratio, toolTranslationX, toolTranslationY;

    if (this.props.icon && transformations[this.props.icon]) {
      ratio = 0.5 * (transformations[this.props.icon].width > transformations[this.props.icon].height
        ? this.props.width / transformations[this.props.icon].width
        : this.props.height / transformations[this.props.icon].height
      );

      toolTranslationX = this.props.width  / 2 - ratio * transformations[this.props.icon].width  / 2 - ratio * transformations[this.props.icon].x;
      toolTranslationY = this.props.height / 2 - ratio * transformations[this.props.icon].height / 2 - ratio * transformations[this.props.icon].y - this.props.height / 4.8;
    }

    const Component = this.props.svg ? 'svg' : 'g';

    return (
      <Component
        className='button'
        width = {this.props.width}
        height = {this.props.height}
        style = {{backgroundColor : this.props.selectedTool.tool === this.props.tool ? 'cyan' : undefined}}>
        <rect
          width={this.props.width}
          height={this.props.height}
          fill = {this.props.selectedTool.tool === this.props.tool && this.props.fill === 'none' ? 'cyan' : this.props.fill}
          stroke = {this.props.selectedTool.tool === this.props.tool && this.props.fill !== 'none' ? 'cyan' : 'black'}
          strokeWidth={this.props.selectedTool.tool === this.props.tool && this.props.fill !== 'none' ? '4' : '1'}
          rx={ this.props.width / 4 }
          ry={ this.props.width / 4 }
          />
        { this.props.icon && transformations[this.props.icon] && (
          <use
            xlinkHref={`#${this.props.icon}`}
            transform = {`rotate(${this.props.rotate}, ${this.props.width / 2}, ${this.props.height / 2 - 10}) translate(${toolTranslationX},${toolTranslationY}) scale(${ratio},${ratio}) `}
            //transform={`scale(${ratio},${ratio})`}
            />
        )}
        <text x = {this.props.width / 2} y = {this.props.height - this.props.height / 4.8} textAnchor = 'middle' fontSize="60%">
          {this.props.badge}
        </text>
        <rect
          width={this.props.width}
          height={this.props.height}
          fill = {'black'}
          opacity='0'
          stroke = 'none'
          onClick = { () => { this.props.selectTool(this.props.tool, this.props.field, this.props.value) } }
          />
      </Component>
    )

  }
}

Button.defaultProps = {
  svg : false,
  rotate : 0,
  fill : 'none',
}

const mapStateToProps = (state) => {
  return { selectedTool : state.tool || {} }
}

export default connect(mapStateToProps, { selectTool })(Button);



// WEBPACK FOOTER //
// ./src/components/Button.js